import { Box, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ContactUsForm from 'src/components/ContactUs/ContactUsForm'
import { NotificationManager } from 'src/functions/notifications'
import { ISendEmailToDealerGQL, IContactSalesInput, IContactUsForm, IReducer } from 'src/interface'
import { saveContactSalesGQL } from 'src/services/graphql/schemas/contactSales'
import { sendEmailToDealerGQL } from 'src/services/graphql/schemas/emails'
import { getCountryName, getDomesticDealers, getInternationalDealers, getStateName } from 'src/utils'

export default function FormContainer() {
  const navigate = useNavigate()
  const isAuthenticated = useSelector((state: IReducer) => state.accountReducer.isAuthenticated)
  const dataCountriesReducer = useSelector((state: IReducer) => state.dataCountriesReducer)
  const dataContactReducer = useSelector((state: IReducer) => state.dataContactReducer)
  const userInfo = useSelector((state: IReducer) => state.accountReducer.userInfo)
  const [cookies] = useCookies(['country_code'])
  const [countryCode, setCountryCode] = useState(cookies.country_code.toUpperCase())
  const [initialValues, setInitialValues] = useState({})
  const [isLoading, setLoading] = useState(false)
  const [stateSelected, setStateSelected] = useState('none')

  const showErrorMessage = () => NotificationManager.error(<FormattedMessage id='notification.systemError' />)

  const prepareFormData = (values: IContactUsForm) => {
    const { name, email, phone, comment, country, state, organization } = values
    let stateName, dealersToSendEmail
    const countryName = getCountryName(country)
    if (state) stateName = getStateName(state)
    const saveContactSalesPayload: IContactSalesInput = {
      email,
      name,
      phone,
      comments: comment,
      country: countryName,
      state: stateName,
      formSource: 'Sales Page',
      organization,
      stullerAccount: userInfo?.BillToAccount
    }
    const userData = {
      FirstName: values.name,
      Email: values.email,
      PhoneNumber: values.phone,
      AccountNumber: userInfo?.BillToAccount
    }
    if (countryName === 'United States') {
      dealersToSendEmail = getDomesticDealers(stateSelected, dataContactReducer)
    } else {
      dealersToSendEmail = getInternationalDealers(countryCode, dataContactReducer, dataCountriesReducer)
    }
    const sendEmailToDealerPayload: ISendEmailToDealerGQL = {
      userInfo: userData,
      productInfo: 'Sales Page',
      dealersToSendEmail,
      comments: values.comment,
      country: countryName,
      state: stateName,
      organization
    }
    return {
      saveContactSalesPayload,
      sendEmailToDealerPayload
    }
  }

  const onSubmit = async (values: IContactUsForm) => {
    setLoading(true)
    const { saveContactSalesPayload, sendEmailToDealerPayload } = prepareFormData(values)
    const saveContactSalesResponsee = await saveContactSalesGQL(saveContactSalesPayload)
    if (saveContactSalesResponsee === 200) {
      const sendEmailResponse = await sendEmailToDealerGQL(sendEmailToDealerPayload)
      if (sendEmailResponse === 200) {
        NotificationManager.success(<FormattedMessage id='notification.messageSent' />)
        return navigate('/confirmation-email-sent', { replace: true })
      }
    }
    showErrorMessage()
    setLoading(false)
  }

  useEffect(() => {
    if (isAuthenticated) {
      setInitialValues({
        name: userInfo.FirstName,
        email: userInfo.Email,
        phone: userInfo.BillToAccountObj.PhoneNumber,
        country: countryCode.toUpperCase(),
        organization: userInfo.BillToAccountObj.CompanyName,
        state: 'none'
      })
    } else {
      setInitialValues({
        country: countryCode.toUpperCase(),
        state: 'none'
      })
    }
  }, [isAuthenticated])

  return (
    <Box>
      <Box sx={{ justifySelf: 'start', position: 'sticky', top: 50, width: '100%' }}>
        <Typography variant='h6' sx={{ textAlign: 'left', mb: 2 }}>
          <FormattedMessage id='sales.getInTouch' />
        </Typography>
        <ContactUsForm
          isLoading={isLoading}
          initialValuesData={initialValues}
          onSubmit={onSubmit}
          disabledField={false}
          countryCode={countryCode}
          setCountryCode={setCountryCode}
          setStateCode={setStateSelected}
          stateSelected={stateSelected}
        />
      </Box>
    </Box>
  )
}
